export default "__VITE_ASSET__cjyAC5mS__"